import React, { useEffect, useRef, useState } from 'react';
import {
  MonitoringTestKind,
  sendMonitoringNotificationTest,
} from 'services/actions/monitoring_notification_tests';
import { apiErrorMessage } from 'services/ensure_ok';
import { Container } from './styles';

interface TestState {
  status: 'sending' | 'sent' | 'failed';
  message: string;
}

const TESTS: Array<{ kind: MonitoringTestKind; icon: string; label: string; sent: string }> = [
  {
    kind: 'email',
    icon: 'mail_outline',
    label: 'Testar email',
    sent: 'E-mail de teste enviado. Confira a sua caixa de entrada.',
  },
  {
    kind: 'sound',
    icon: 'volume_up',
    label: 'Testar aviso sonoro',
    sent: 'Aviso enviado. Se o som não tocar, confira o volume desta aba.',
  },
  {
    kind: 'push',
    icon: 'notifications',
    label: 'Testar push do navegador',
    sent: 'Notificação enviada. Ela aparece na área de trabalho em instantes.',
  },
];

const MonitoringNotificationTests = ({ companyId }: { companyId: number }) => {
  const [tests, setTests] = useState<Partial<Record<MonitoringTestKind, TestState>>>({});
  const mounted = useRef(true);

  useEffect(
    () => () => {
      mounted.current = false;
    },
    [],
  );

  const update = (kind: MonitoringTestKind, state: TestState) => {
    if (mounted.current) setTests((current) => ({ ...current, [kind]: state }));
  };

  const run = (kind: MonitoringTestKind, sent: string) => {
    update(kind, { status: 'sending', message: 'Enviando...' });
    sendMonitoringNotificationTest(kind, companyId)
      .then(() => update(kind, { status: 'sent', message: sent }))
      .catch((error) =>
        update(kind, {
          status: 'failed',
          message: apiErrorMessage(
            error,
            'Não foi possível enviar o teste agora. Tente novamente em alguns minutos.',
          ),
        }),
      );
  };

  return (
    <Container className="card shadow">
      <div className="card-body">
        <h5 className="font-weight-bold">Testar notificações</h5>
        <p>
          Envie notificações de teste para confirmar se sua configuração está funcionando
          corretamente.
        </p>
        <div className="row">
          {TESTS.map(({ kind, icon, label, sent }) => (
            <div className="col-md-4 col-12 mb-2" key={kind}>
              <button
                type="button"
                className="test-button"
                disabled={tests[kind]?.status === 'sending'}
                onClick={() => run(kind, sent)}
              >
                <i className="material-icons" aria-hidden="true">
                  {icon}
                </i>
                {label}
              </button>
              <p
                className={`test-feedback ${
                  tests[kind]?.status === 'failed' ? 'text-danger' : 'text-muted'
                }`}
                role="status"
              >
                {tests[kind]?.message}
              </p>
            </div>
          ))}
        </div>
      </div>
    </Container>
  );
};

export default MonitoringNotificationTests;
